import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
const HeroSection = () => {
  const { user } = useAuth();

  return (
    <section className="hero-section relative z-10 mx-auto max-w-7xl px-4 pb-32 pt-16 sm:px-6 sm:pb-28 md:pt-28 lg:px-8 lg:pb-40">
      <div className="mx-auto max-w-[1440px] text-center">

        {/* Heading */}
        <h1 className="hidden md:block mt-6 text-4xl sm:text-6xl">
          <span className="reveal reveal-up delay-2 bg-gradient-to-r from-white/45 via-white to-white/45 sm:from-white/30 sm:via-white sm:to-white/30 bg-clip-text text-transparent">
          Premium RDP Infrastructure.
          </span>
          <span className="reveal reveal-up delay-3 block bg-gradient-to-r from-white/45 via-white to-white/45 sm:from-white/30 sm:via-white sm:to-white/30 bg-clip-text text-transparent py-2">
          Built for Speed and Stability.
          </span>
        </h1>    
        <h1
          className="block md:hidden reveal-nav mt-6 w-full max-w-[1320px]
          bg-[linear-gradient(90deg,#ffffff70,#ffffff,#ffffff70)]
          bg-clip-text pb-2 text-center font-clash text-[42px] font-normal
          leading-[0.95] tracking-[-1.4px] text-transparent
          sm:text-[56px] sm:tracking-[-1.8px]
          md:text-[68px] md:tracking-[-2px]
          lg:text-[91px] lg:leading-[78px] lg:tracking-[-2.56px]"
        >
          <span className="block">
            Premium RDP Infrastructure.
          </span>

          <span className="block py-2">
            Built for Speed and Stability.
          </span>
        </h1>      

        {/* Description */}
        <p className="reveal reveal-blur delay-4 mx-auto mt-5 max-w-2xl text-sm text-[#9C9EAC] sm:text-base">
          Enterprise-grade hosting powered by next-gen hardware and ultra-fast
          networking. Deploy in seconds. Scale without limits. Perform without
          compromise.
        </p>

        {/* Buttons */}
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to={user ? "/dashboard" : "/signup"}
            className="animate-fadeInSoft group relative overflow-hidden rounded-xl
            border border-[#929DB8]/45
            bg-gradient-to-b from-[#FFFFFF00] via-[#2333FF40] to-[#2333FF]
            px-7 py-3 text-sm font-semibold text-white
            transition-all duration-300
            hover:-translate-y-1
            hover:border-[#B4BDCA]/65
            hover:shadow-[0_8px_25px_rgba(35,51,255,0.5)]"
            style={{ animationDelay: "240ms" }}
          >
            <span className="relative z-10">{user ? "Dashboard" : "Sign up"}</span>

            {/* light sweep */}
            <span
              className="pointer-events-none absolute -left-[120%] top-0 h-full w-[120%]
              bg-gradient-to-r from-transparent via-white/30 to-transparent
              opacity-0 transition-all duration-700
              group-hover:left-[120%] group-hover:opacity-100"
            />
          </Link>

          <button
            type="button"
            onClick={() => document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth", block: "start" })}
            className="animate-fadeInSoft group relative overflow-hidden rounded-xl
            px-7 py-3 text-sm font-semibold text-white
            bg-gradient-to-b from-[#2E4175] to-[#223366]
            border border-[#929DB8]/45
            transition-all duration-300
            hover:-translate-y-1
            hover:border-[#B4BDCA]/65
            hover:shadow-[0_8px_20px_rgba(0,0,0,0.45)]"
            style={{ animationDelay: "320ms" }}
          >
            <span className="relative z-10">Pricing</span>

            {/* shimmer sweep */}
            <span
              className="pointer-events-none absolute -left-[120%] top-0 h-full w-[120%]
              bg-gradient-to-r from-transparent via-white/20 to-transparent
              opacity-0 transition-all duration-700
              group-hover:left-[120%] group-hover:opacity-100"
            />
          </button>
        </div>
      </div>

    </section>
  );
};

export default HeroSection;